module.exports = __webpack_public_path__ + "static/campaign_x_homepage_screenshot-c1c4b65b144b509c045152bf755f4759.jpg";